export const STOCKING_APPLE_PATH = '/stocking-apple-cream'
export const STOCKING_APPLE_PRODUCT_SLUG = 'stocking-celana-apple-b08b'
export const STOCKING_APPLE_PRODUCT_PATH = `/produk/${STOCKING_APPLE_PRODUCT_SLUG}`
export const STOCKING_APPLE_PRODUCT_NAME = 'Stocking Celana Apple B08B warna cream'
export const STOCKING_APPLE_CATEGORY = 'Kaos Kaki'
export const STOCKING_APPLE_LEAD_ITEM = {
  item_id: STOCKING_APPLE_PRODUCT_SLUG,
  item_name: STOCKING_APPLE_PRODUCT_NAME,
  item_category: STOCKING_APPLE_CATEGORY,
}

export const STOCKING_APPLE_FALLBACK_IMAGE =
  'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/06/11/e5390f7cce6141d7a08d98410a27bb92.jpeg'

export const STOCKING_APPLE_MESSAGE =
  'Halo Dropify, saya mau cek Stocking Celana Apple B08B warna cream untuk stok toko. Kebutuhan: ___ lusin. Kota tujuan: ___. Mohon cocokkan kode pada barang dengan SKU B08B, lalu informasikan ukuran, bahan, isi per lusin, stok, MOQ, dan quotation.'

export const STOCKING_APPLE_FAQ = [
  {
    q: 'Apakah Stocking Apple B08B warna cream tersedia sekarang?',
    a: 'Ketersediaan warna cream diperiksa saat Anda mengirim jumlah kebutuhan. Minta admin memastikan stok B08B cream sebelum mengunci pesanan.',
  },
  {
    q: 'Berapa minimum order Stocking Apple B08B cream?',
    a: 'Acuan minimum order kategori kaos kaki adalah 50 lusin. Ketentuan khusus B08B, isi per lusin, dan kemungkinan campur warna perlu dikonfirmasi admin sebelum quotation.',
  },
  {
    q: 'Ukuran dan bahan Stocking Apple B08B cream apa saja?',
    a: 'Keterangan ukuran dan komposisi bahan B08B perlu dicocokkan dengan barang yang tersedia. Minta foto label atau detail produk dari admin jika informasi ini menentukan pilihan toko Anda.',
  },
  {
    q: 'Mengapa kode pada gambar perlu diperiksa lagi?',
    a: 'SKU katalog tercatat sebagai B08B, sedangkan tulisan pada gambar produk terbaca 8088. Minta admin mencocokkan kode pada barang yang tersedia sebelum PO.',
  },
  {
    q: 'Bisa mencampur cream dengan warna lain dalam satu pesanan?',
    a: 'Kirim jumlah yang diinginkan untuk cream dan setiap warna lain. Admin akan memeriksa pilihan warna, komposisi kemasan, serta ketentuan campurnya.',
  },
  {
    q: 'Bagaimana cara meminta harga grosir dan ongkir?',
    a: 'Sebutkan Stocking Celana Apple B08B warna cream, jumlah dalam lusin, dan kota tujuan melalui WhatsApp. Admin memeriksa stok, ketentuan pembelian, harga, dan ongkir sebelum menyiapkan quotation.',
  },
]
